/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { GenericApiResponseExportedModuleData } from './genericApiResponseExportedModuleData';
import type { GenericApiResponseExportedModuleMessage } from './genericApiResponseExportedModuleMessage';
import type { GenericApiResponseExportedModulePagination } from './genericApiResponseExportedModulePagination';
import type { GenericApiResponseExportedModuleError } from './genericApiResponseExportedModuleError';

export interface GenericApiResponseExportedModule {
  data?: GenericApiResponseExportedModuleData;
  message?: GenericApiResponseExportedModuleMessage;
  pagination?: GenericApiResponseExportedModulePagination;
  error?: GenericApiResponseExportedModuleError;
  statusCode?: number;
}
